import React from 'react'
import { View, StyleSheet } from 'react-native'
import SelectionIconButton from './SelectionIconButton'

export const SelectIconButtonGroup = React.memo(function SelectIconButtonGroup({
  items,
  selectedItem,
  onItemSelect,
  style,
  disabled,
  testIDPrefix = 'payment-method'
}) {
  const calculateWidth = () => {
    const count = items.length
    return ((100 - (count-1))/count) + '%'
  }

  return (
    <View style={[styles.container, style]}>
      {items?.map((item, index) => (
        <SelectionIconButton
          key={item+index}
          onPress={() => onItemSelect(item)}
          text={item.iconText}
          iconName={item.icon}
          selected={selectedItem?.id === item.id}
          width={calculateWidth()}
          disabled={disabled}
          testID={`${testIDPrefix}-${item.id}`}
        />
      ))}
    </View>
  )
}, function(prev, next) {
  if (prev.selectedItem?.id !== next.selectedItem?.id) {
    return false
  }
  if (prev.items == null) {
    return false
  }
  if (prev.items !== next.items) {
    return false
  }
  return true
})

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}) 